module.exports = __webpack_public_path__ + "static/media/LUDIS-icon.1d030860.svg";